import * as _ from 'lodash'

import {ESRecord} from "../lib/ESRecord";
import {ESDataStore} from "../lib/ESDataStore";





export class RecordQueue<RecordTemplate extends ESRecord> {


  private _dctRecords: {[id:number]: RecordTemplate}
  private _arrRecords: RecordTemplate[]
  private _Id: string

  constructor(sIdField: string){
    this._Id = sIdField
    this._dctRecords = {}
    this._arrRecords = []
  }

  queue(...records: RecordTemplate[]){

      _.forEach(records, (record) => {
        let idValue = (<any> record)[this._Id]
        if(!(idValue in this._dctRecords)){
          this._dctRecords[idValue] = record
          this._arrRecords.push(record)
        }
      })
  }

  dequeue(i: number): RecordTemplate[] {

    // Remove from array
    let removed = this._arrRecords.splice(0,i)

    // Remove from dictionary
    _.forEach(removed, (record) => {
      let idValue = (<any> record)[this._Id]
      if(idValue in this._dctRecords){
        delete this._dctRecords[idValue]
      }
    })

    return removed

  }


  queueLength(): number {
    return this._arrRecords.length
  }



  contains(id: number): boolean {
    return (id in this._dctRecords)
  }


}